const s3config  = {
    public_bucket: 'hf-public-content',
    creator_bucket: 'hf-creator-uploads',
    region: 'us-east-1'
};

export default s3config;